/* eslint-disable react-hooks/exhaustive-deps */
import 'antd/dist/antd.min.css';
import 'antd.css';
import { Form as AntForm } from 'antd';
import React, { useState } from 'react';
import { Container, Form, Row, Button } from 'react-bootstrap';
import LoadingContent from 'components/LoadingContent';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import EditableTable from 'components/table/antd-etable/antd-etable';
import SumarryTable from 'components/table/SumarryTable';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import FormCreateGpaForecastModal from './components/formCreateGpaForecastModal';
import gpaForecastServices from 'services/gpaforecast.services';
import gpaForecastDetailServices from 'services/gpaforecastDetail.services';
import { useAppDispatch } from 'app/hooks';
import _ from "lodash";
import moment from 'moment';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { getCollege, getHighSchool } from 'app/highSchoolSlice/highSchoolSlice';
import { tryParseJSON, removeDuplicate } from 'components/helper/helper';
import { scrollToObject} from 'components/helper/ui_helper';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';
import { useHistory } from 'react-router-dom';
import { getGradeAndCourse } from 'app/course/courseSlice';
//import Cookies from 'js-cookie';

export const findGradeIndex = (gradeNo:number, schoolItem: any) => {
    if (schoolItem) {
      let gradeArr = schoolItem?.grade ?? [];
      if (gradeArr && gradeArr.length>0){
        for(let i=0; i<gradeArr.length; i++) {
          if (gradeArr[i] === `${gradeNo}th`) {
            return i;
          }
        }
      }
    }
    return -1;
}

export const getAcademicYearOptions = (gradeNo: number, schoolItem: any) => {
  var ret: any[] = [];
  if (schoolItem) {
    let gradeIdx = findGradeIndex(gradeNo, schoolItem);
    let list_years:any[] = schoolItem?.academic_year ?? [];
    if (list_years && list_years.length>0) {
      if (gradeIdx>=0) {     
        if (gradeIdx<list_years.length) {
          ret.push(list_years[gradeIdx]);
        }
      }
      else{
        for(let i=0; i< list_years.length; i++) {
          ret.push(list_years[i]);
        }
      }
    }
  }
  return removeDuplicate(ret);
}

interface Props {}

const GpaForecaster = (props: Props) => {
  const [runCount, setRunCount] = React.useState(0);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);

  const [gpaForecast9, setGpaForecast9] = React.useState<any[]>([]);
  const [gpaForecast10, setGpaForecast10] = React.useState<any[]>([]);
  const [gpaForecast11, setGpaForecast11] = React.useState<any[]>([]);
  const [gpaForecast12, setGpaForecast12] = React.useState<any[]>([]);
  const [gpaForecast13, setGpaForecast13] = React.useState<any[]>([]);

  const [gpaForecast9Data, setGpaForecast9Data] = React.useState<any[]>([]);
  const [gpaForecast9Custom, setGpaForecast9Custom] = React.useState<any[]>([]);
  const [gpaForecast9Average, setGpaForecast9Average] = React.useState<any[]>([]);
  const [gpaForecast10Data, setGpaForecast10Data] = React.useState<any[]>([]);
  const [gpaForecast10Custom, setGpaForecast10Custom] = React.useState<any[]>([]);
  const [gpaForecast10Average, setGpaForecast10Average] = React.useState<any[]>([]);
  const [gpaForecast11Data, setGpaForecast11Data] = React.useState<any[]>([]);
  const [gpaForecast11Custom, setGpaForecast11Custom] = React.useState<any[]>([]);
  const [gpaForecast11Average, setGpaForecast11Average] = React.useState<any[]>([]);
  const [gpaForecast12Data, setGpaForecast12Data] = React.useState<any[]>([]); 
  const [gpaForecast12Custom, setGpaForecast12Custom] = React.useState<any[]>([]);
  const [gpaForecast12Average, setGpaForecast12Average] = React.useState<any[]>([]);
  const [gpaForecast13Data, setGpaForecast13Data] = React.useState<any[]>([]); 
  const [gpaForecast13Custom, setGpaForecast13Custom] = React.useState<any[]>([]);
  const [gpaForecast13Average, setGpaForecast13Average] = React.useState<any[]>([]);

  const [currentPage9Data,setCurrentPage9Data] = useState(1);
  const [currentRow9Data,setCurrentRow9Data] = useState<any>(null);
  const [changedData9Data,setChangedData9Data] = useState<any[]>([]);
  const [form9] = AntForm.useForm();

  const [currentPage10Data,setCurrentPage10Data] = useState(1);
  const [currentRow10Data,setCurrentRow10Data] = useState<any>(null);
  const [changedData10Data,setChangedData10Data] = useState<any[]>([]);
  const [form10] = AntForm.useForm();

  const [currentPage11Data,setCurrentPage11Data] = useState(1);
  const [currentRow11Data,setCurrentRow11Data] = useState<any>(null);
  const [changedData11Data,setChangedData11Data] = useState<any[]>([]);
  const [form11] = AntForm.useForm();

  const [currentPage12Data,setCurrentPage12Data] = useState(1); 
  const [currentRow12Data,setCurrentRow12Data] = useState<any>(null);
  const [changedData12Data,setChangedData12Data] = useState<any[]>([]);
  const [form12] = AntForm.useForm();

  const [currentPage13Data,setCurrentPage13Data] = useState(1); 
  const [currentRow13Data,setCurrentRow13Data] = useState<any>(null);
  const [changedData13Data,setChangedData13Data] = useState<any[]>([]);
  const [form13] = AntForm.useForm();

  const [currentPage9Custom,setCurrentPage9Custom] = useState(1);
  const [currentRow9Custom,setCurrentRow9Custom] = useState<any>(null);
  const [changedData9Custom,setChangedData9Custom] = useState<any[]>([]);
  const [form9Custom] = AntForm.useForm();
  const [schoolOptions9, setSchoolOptions9] = useState<any[]>([]);
  const [openAddDialog9, setOpenAddDialog9] = useState<boolean>(false);

  const [currentPage10Custom,setCurrentPage10Custom] = useState(1);
  const [currentRow10Custom,setCurrentRow10Custom] = useState<any>(null);
  const [changedData10Custom,setChangedData10Custom] = useState<any[]>([]);
  const [form10Custom] = AntForm.useForm();
  const [schoolOptions10, setSchoolOptions10] = useState<any[]>([]); 
  const [openAddDialog10, setOpenAddDialog10] = useState<boolean>(false);

  const [currentPage11Custom,setCurrentPage11Custom] = useState(1);
  const [currentRow11Custom,setCurrentRow11Custom] = useState<any>(null);
  const [changedData11Custom,setChangedData11Custom] = useState<any[]>([]);
  const [form11Custom] = AntForm.useForm();
  const [schoolOptions11, setSchoolOptions11] = useState<any[]>([]); 
  const [openAddDialog11, setOpenAddDialog11] = useState<boolean>(false);

  const [currentPage12Custom,setCurrentPage12Custom] = useState(1); 
  const [currentRow12Custom,setCurrentRow12Custom] = useState<any>(null);
  const [changedData12Custom,setChangedData12Custom] = useState<any[]>([]);
  const [form12Custom] = AntForm.useForm();
  const [schoolOptions12, setSchoolOptions12] = useState<any[]>([]); 
  const [openAddDialog12, setOpenAddDialog12] = useState<boolean>(false);


  const [currentPage13Custom,setCurrentPage13Custom] = useState(1); 
  const [currentRow13Custom,setCurrentRow13Custom] = useState<any>(null);
  const [changedData13Custom,setChangedData13Custom] = useState<any[]>([]);
  const [form13Custom] = AntForm.useForm();
  const [schoolOptions13, setSchoolOptions13] = useState<any[]>([]); 
  const [openAddDialog13, setOpenAddDialog13] = useState<boolean>(false);

  const [loading, setLoading] = React.useState(false);
  const [loading9, setLoading9] = React.useState(false);
  const [loading10, setLoading10] = React.useState(false);
  const [loading11, setLoading11] = React.useState(false);
  const [loading12, setLoading12] = React.useState(false);
  const [loading13, setLoading13] = React.useState(false);

  const dispatch = useAppDispatch();
  const history = useHistory();
  let studentId = getUserId();
  let token = getAccessToken();

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = () => {
    history.push(routers.personalSum.path.replace(':id', studentId));
  };
  
  const getGpaForeCastByGradeNo  = async(studentId: string, gradeNo: number) => {
    const ret:any[] = await gpaForecastServices.getGpaForeCastByGradeNo(studentId, gradeNo);
    return ret;
  };

  const getGpaDetails = async(ret:any[]) => {
    let arr:any[] = [];
    if (ret && ret.length>0) {
      for (let i=0; i<ret.length; i++) {
          let item = ret[i];
          let ret2:any[] = await gpaForecastDetailServices.getGpaForeCastDetails(item.gpa_forecast_id);
          if (ret2 && ret2.length>0) {
            for(let j=0; j<ret2.length; j++) {
              arr.push(ret2[j]);
            }
          }
      }        
    }
    return arr;
  }

  const formatDecial =(num:number) =>{
    return (Math.round(num * 100) / 100).toFixed(2);
  } 
  
  const calcAverageGpa = (data:any[]) => {
    if (data && data.length>0) {
      let sum1 = 0;
      let sum2 = 0;
      let sumCredit = 0;
      for(let i=0; i< data.length; i++) {
        sum1 += data[i].unweighted_point * data[i].credit;
        sum2 += data[i].weighted_point * data[i].credit;
        sumCredit += data[i].credit;
      }
      return { 
        unweighted_point: sum1 !== 0 ? sum1/sumCredit : 0, 
        weighted_point:   sum2 !== 0 ? sum2/sumCredit : 0, 
      }
    }
    return { unweighted_point: 0, weighted_point: 0 }
  }
  const CalcAverageGpaPoint = (data:any[], gradeNo: number) => {
    let gradeth = `${gradeNo}th Grade`;
    if (gradeNo === 13) gradeth = "College Course";
    if (data && data.length>0) {
      let sum1 = 0;
      let sum2 = 0;
      let sumCredit = 0;
      for(let i=0; i< data.length; i++) {
        sum1 += data[i].unweighted_point * data[i].credit;
        sum2 += data[i].weighted_point * data[i].credit;
        sumCredit += data[i].credit;
      }
      return [{ 
        grade: gradeth, 
        unweighted_point: sum1 !== 0 ? formatDecial(sum1/sumCredit) : 0, 
        weighted_point:   sum2 !== 0 ? formatDecial(sum2/sumCredit) : 0,
      }]
    }
    return [{ grade: gradeth, unweighted_point: 0, weighted_point: 0}]
  }
  /**
   * Cumulative (multi-grade) GPA must be credit-weighted across every detail row in the
   * pooled grades, not an average of each grade's already-computed average. Averaging
   * per-grade averages silently ignores that grades can carry very different total
   * credit loads (e.g. 20 credits in 9th vs 40 in 10th), which skews the cumulative GPA
   * shown to the student. Pooling the rows first and calling calcAverageGpa once (which
   * already does sum(point*credit)/sum(credit)) gives the mathematically correct result.
   */
  const poolGpaData = (...grades: (any[] | undefined | null)[]) => {
    let pooled: any[] = [];
    for (let i = 0; i < grades.length; i++) {
      const g = grades[i];
      if (g && g.length > 0) pooled = pooled.concat(g);
    }
    return pooled;
  }

  const CalcAverageGpa_10Grade = (data9:any[], data10:any[]) => {
    let gradeth = '9th-10th Grade';
    let arr:any[] = [];
    let avg9_10:any = calcAverageGpa(poolGpaData(data9, data10));

    arr.push(CalcAverageGpaPoint(data10, 10)[0]);
    arr.push({grade: gradeth, unweighted_point: formatDecial(avg9_10.unweighted_point), weighted_point: formatDecial(avg9_10.weighted_point)});
    return arr;
  }

  const CalcAverageGpa_11Grade = (data9:any[], data10:any[], data11:any[]) => {
    let grade_9_11th = '9th-11th Grade';
    let grade_10_11th = '10th-11th Grade';
    let arr:any[] = [];
    let avg9_11:any = calcAverageGpa(poolGpaData(data9, data10, data11));

    arr.push(CalcAverageGpaPoint(data11, 11)[0]);
    arr.push({grade: grade_9_11th, unweighted_point: formatDecial(avg9_11.unweighted_point), weighted_point: formatDecial(avg9_11.weighted_point)});

    let avg10_11:any = calcAverageGpa(poolGpaData(data10, data11));
    arr.push({grade: grade_10_11th, unweighted_point: formatDecial(avg10_11.unweighted_point), weighted_point: formatDecial(avg10_11.weighted_point)});
    return arr;
  }

  const CalcAverageGpa_12Grade = (data9:any[], data10:any[], data11:any[], data12:any[]) => {
    let grade_9_12th = '9th-12th Grade';
    let grade_10_12th = '10th-12th Grade';
    let arr:any[] = [];
    let avg9_12:any = calcAverageGpa(poolGpaData(data9, data10, data11, data12));

    arr.push(CalcAverageGpaPoint(data12, 12)[0]);
    arr.push({grade: grade_9_12th, unweighted_point: formatDecial(avg9_12.unweighted_point), weighted_point: formatDecial(avg9_12.weighted_point)});

    let avg10_12:any = calcAverageGpa(poolGpaData(data10, data11, data12));
    arr.push({grade: grade_10_12th, unweighted_point: formatDecial(avg10_12.unweighted_point), weighted_point: formatDecial(avg10_12.weighted_point)});
    return arr;
  }

  const mergeArrayGpa = (arrOrigin:any[], arrCustom:any[]) => {
    let arr:any[] = [];
    if (arrOrigin && arrOrigin.length>0) {
      for(let i=0; i< arrOrigin.length; i++) {
        arr.push(arrOrigin[i]);
      }
    }
    if (arrCustom && arrCustom.length>0) {
      for(let j=0; j< arrCustom.length; j++) {
        arr.push(arrCustom[j]);
      }
    }
    return arr;
  };

  const updateCalcAllData = () => {
    let arr9: any [] = mergeArrayGpa(gpaForecast9Data, gpaForecast9Custom);
    let arr10:any [] = mergeArrayGpa(gpaForecast10Data, gpaForecast10Custom);
    let arr11:any [] = mergeArrayGpa(gpaForecast11Data, gpaForecast11Custom);
    let arr12:any [] = mergeArrayGpa(gpaForecast12Data, gpaForecast12Custom);
    let arr13:any [] = mergeArrayGpa(gpaForecast13Data, gpaForecast13Custom);
    
    setGpaForecast9Average(CalcAverageGpaPoint(arr9, 9));
    setGpaForecast10Average(CalcAverageGpa_10Grade(arr9, arr10));
    setGpaForecast11Average(CalcAverageGpa_11Grade(arr9, arr10, arr11));
    setGpaForecast12Average(CalcAverageGpa_12Grade(arr9, arr10, arr11, arr12));

    setGpaForecast13Average(CalcAverageGpaPoint(arr13, 13));
  }

  function compareDate(a:any, b:any) {
    return moment(a.updated_at).unix() - moment(b.updated_at).unix();
  }
  function compareSeqNo( a:any, b:any ) {
    if ( a.seq_no < b.seq_no ){
      return -1;
    }
    if ( a.seq_no > b.seq_no ){
      return 1;
    }
    return 0;
  }

  const sortGpaDetails = (arr: any[]) =>{   
    arr.sort(compareDate);
  }

  const refreshGpa = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      const res = await dispatch(getHighSchool(studentId)).unwrap(); 
      let highSchools:any = [];
      if (res) {
        highSchools = tryParseJSON(res?.high_school_array);
      }

      setLoading12(true);
      try {
        let arr9:any[] = await getGpaForeCastByGradeNo(studentId, 9) ?? [];
        setGpaForecast9(arr9);

        let arr9_details = await getGpaDetails(arr9);     
        let arr9_origin:any[] = arr9_details.filter( (item:any) => (item.is_custom === false));
        setGpaForecast9Data(arr9_origin);

        let arr9_custom:any[] = arr9_details.filter( (item:any) => (item.is_custom === true));
        setGpaForecast9Custom(arr9_custom);
        setGpaForecast9Average(CalcAverageGpaPoint(arr9_details, 9));

        let arr10 = await getGpaForeCastByGradeNo(studentId, 10);
        setGpaForecast10(arr10);

        let arr10_details = await getGpaDetails(arr10);
        let arr10_origin:any[] = arr10_details.filter( (item:any) => (item.is_custom === false));
        setGpaForecast10Data(arr10_origin);

        let arr10_custom:any[] = arr10_details.filter( (item:any) => (item.is_custom === true));
        setGpaForecast10Custom(arr10_custom);
        setGpaForecast10Average(CalcAverageGpa_10Grade(arr9_details, arr10_details));

        let arr11 = await getGpaForeCastByGradeNo(studentId, 11);
        setGpaForecast11(arr11);

        let arr11_details = await getGpaDetails(arr11);
        let arr11_origin:any[] = arr11_details.filter( (item:any) => (item.is_custom === false));
        setGpaForecast11Data(arr11_origin);

        let arr11_custom:any[] = arr11_details.filter( (item:any) => (item.is_custom === true));
        setGpaForecast11Custom(arr11_custom);
        setGpaForecast11Average(CalcAverageGpa_11Grade(arr9_details, arr10_details, arr11_details));

        let arr12 = await getGpaForeCastByGradeNo(studentId, 12);
        setGpaForecast12(arr12);

        let arr12_details = await getGpaDetails(arr12);
        let arr12_origin:any[] = arr12_details.filter( (item:any) => (item.is_custom === false));
        setGpaForecast12Data(arr12_origin);
        
        let arr12_custom:any[] = arr12_details.filter( (item:any) => (item.is_custom === true));
        setGpaForecast12Custom(arr12_custom);
        setGpaForecast12Average(CalcAverageGpa_12Grade(arr9_details, arr10_details, arr11_details, arr12_details))


        let arr13:any[] = await getGpaForeCastByGradeNo(studentId, 13 ?? []);
        setGpaForecast13(arr13);

        let arr13_details = await getGpaDetails(arr13);     
        let arr13_origin:any[] = arr13_details.filter( (item:any) => (item.is_custom === false));
        setGpaForecast13Data(arr13_origin);

        let arr13_custom:any[] = arr13_details.filter( (item:any) => (item.is_custom === true));
        setGpaForecast13Custom(arr13_custom);
        setGpaForecast13Average(CalcAverageGpaPoint(arr13_details, 13));


        //#region Generate School Options
        let list9:any[] = getSchoolOptions(arr9, highSchools);
        setSchoolOptions9(list9);

        let list10:any[] = getSchoolOptions(arr10, highSchools);
        setSchoolOptions10(list10);

        let list11:any[] = getSchoolOptions(arr11, highSchools);
        setSchoolOptions11(list11);

        let list12:any[] = getSchoolOptions(arr12, highSchools);
        setSchoolOptions12(list12);

        let list13:any[] = getSchoolOptions(arr13, highSchools);
        setSchoolOptions12(list13);

        //#endregion
      }
      catch(ex){
        console.log('Error:', ex);
      }
      setLoading12(false);
    }  
  }

  const genSeqNoDetails = (data:any[]) => {
      let max = 0;
      try {
        if (data && data.length>0)
          for(let i=0; i<data.length; i++) {
            let obj:any = data[i];
            if (max < obj.seq_no) {
              max = obj.seq_no;
            }
          }
      }
      catch(ex){
        //skip
      }
      return max+1;
  }

  const getSchoolOptions = (arr:any[], highSchools:any) => {
    if (arr && arr.length>0) {
      let ret = arr.map((value:any) => ({ 
        name: value.school_name, 
        value: value.gpa_forecast_id,
        gpa_forecast_id: value.gpa_forecast_id,
        school_name: value.school_name,
        schedule: value.schedule,
        school_year: [] as any[],
        school_code: '',
        grading_scale: value.grading_scale,
        highschoolData: null
      }));

      for(let k=0; k< ret.length; k++) {
        let school = highSchools.find((o:any)=> o.school_name === ret[k].school_name);
        if (school) {
          ret[k].school_year = getAcademicYearOptions(9, school);
          ret[k].school_code  = school?.high_school_code ?? '';
          ret[k].highschoolData = Object.assign({},school);
        }
      }
      return ret;
    }
    return [];
  }

  const getSchoolOptionsByCourse = (arr:any[], collegeCourse:any) => {
    console.log('getSchoolOptionsByCourse: arr:', arr);
    if (arr && arr.length>0) {
      let ret:any[] = arr.map((value:any) => ({ 
        name: value.school_name, 
        value: value.gpa_forecast_id,
        gpa_forecast_id: value.gpa_forecast_id,
        school_name: value.school_name,
        schedule: value.schedule,
        school_year: [] as any[],
        school_code: '',
        grading_scale: value.grading_scale,
        highschoolData: null
      }));

      for(let k=0; k< ret.length; k++) {
        console.log('list of arr map ret:', ret);
        let school = collegeCourse.find((o:any)=> o.collegeName === ret[k].school_name);
        console.log('find collegeCourse:', collegeCourse);
        //[0].collegeInformation.college_ceeb
        console.log('find school:', school);
        if (school) {
          let schoolCode = school?.collegeInformation?.college_ceeb ?? school?.collegeInformation?.school?.ceeb  ?? '';
          ret[k].school_year = school.academicYear;
          ret[k].school_code  = schoolCode;
        }
      }
      return ret;
    }
    return [];
  }

  const getData = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      setLoading(true);
      try { 
        const res = await dispatch(getHighSchool(studentId)).unwrap(); 
        let highSchools:any = [];
        if (res) {
          highSchools = tryParseJSON(res?.high_school_array);
        }

        let courseArr:any[] = [];
        const ret2 = await dispatch(getGradeAndCourse(studentId)).unwrap();
        if (ret2) {
          console.log('ret2:', ret2);
          courseArr = tryParseJSON(ret2.college_course_array, []);
        }

        let arr9:any[] = await getGpaForeCastByGradeNo(studentId, 9) ?? [];
        setGpaForecast9(arr9);
        let arr9_details = await getGpaDetails(arr9);
        let arr9_origin:any[] = arr9_details.filter( (item:any) => (item.is_custom === false));
        setGpaForecast9Data(arr9_origin);
        let arr9_custom:any[] = arr9_details.filter( (item:any) => (item.is_custom === true));
        setGpaForecast9Custom(arr9_custom);
        setGpaForecast9Average(CalcAverageGpaPoint(arr9_details, 9));
  
        let arr10 = await getGpaForeCastByGradeNo(studentId, 10);
        setGpaForecast10(arr10);
        let arr10_details = await getGpaDetails(arr10);
        let arr10_origin:any[] = arr10_details.filter( (item:any) => (item.is_custom === false));
        setGpaForecast10Data(arr10_origin);
        let arr10_custom:any[] = arr10_details.filter( (item:any) => (item.is_custom === true));
        setGpaForecast10Custom(arr10_custom);
        setGpaForecast10Average(CalcAverageGpa_10Grade(arr9_details, arr10_details));

        let arr11 = await getGpaForeCastByGradeNo(studentId, 11);
        setGpaForecast11(arr11);
        let arr11_details = await getGpaDetails(arr11);
        let arr11_origin:any[] = arr11_details.filter( (item:any) => (item.is_custom === false));
        setGpaForecast11Data(arr11_origin);
        let arr11_custom:any[] = arr11_details.filter( (item:any) => (item.is_custom === true));
        setGpaForecast11Custom(arr11_custom);
        setGpaForecast11Average(CalcAverageGpa_11Grade(arr9_details, arr10_details, arr11_details));

        let arr12 = await getGpaForeCastByGradeNo(studentId, 12);
        setGpaForecast12(arr12);
        let arr12_details = await getGpaDetails(arr12);
        let arr12_origin:any[] = arr12_details.filter( (item:any) => (item.is_custom === false));
        setGpaForecast12Data(arr12_origin);
        let arr12_custom:any[] = arr12_details.filter( (item:any) => (item.is_custom === true));
        setGpaForecast12Custom(arr12_custom);
        setGpaForecast12Average(CalcAverageGpa_12Grade(arr9_details, arr10_details, arr11_details, arr12_details))

        let arr13 = await getGpaForeCastByGradeNo(studentId, 13);
        setGpaForecast13(arr13);
        let arr13_details = await getGpaDetails(arr13);
        let arr13_origin:any[] = arr13_details.filter( (item:any) => (item.is_custom === false));
        setGpaForecast13Data(arr13_origin);
        let arr13_custom:any[] = arr13_details.filter( (item:any) => (item.is_custom === true));
        setGpaForecast13Custom(arr13_custom);
        setGpaForecast13Average(CalcAverageGpaPoint(arr13_details, 13));

        //#region Generate School Options
        let list9:any[] = getSchoolOptions(arr9, highSchools);
        setSchoolOptions9(list9);

        let list10:any[] = getSchoolOptions(arr10, highSchools);
        setSchoolOptions10(list10);

        let list11:any[] = getSchoolOptions(arr11, highSchools);
        setSchoolOptions11(list11);

        let list12:any[] = getSchoolOptions(arr12, highSchools);
        setSchoolOptions12(list12);

        let list13:any[] = getSchoolOptionsByCourse(arr13, courseArr);
        setSchoolOptions13(list13);
        console.log('list13:', list13);
        //#endregion

        if (arr9.length === 0 && arr10.length === 0 && arr11.length===0 && arr12.length ===0 && arr13.length ===0)  {
          if (runCount===0) {
            setRunCount(runCount+1);
            await runResync();
          }
        }

      }
      catch(ex) {
        console.log('Error: ', ex);
      }    
      setLoading(false);
    } else {
      handleLogout();
    }
  };


  const runResync = async() => {
    setLoading9(true);
    setLoading10(true);
    setLoading11(true);
    setLoading12(true);
    setLoading13(true);
    await gpaForecastServices.syncGpaForecast(studentId);
    setLoading9(false);
    setLoading10(false);
    setLoading11(false);
    setLoading12(false);
    setLoading13(false);
    await getData();
  }

  React.useEffect(() => {
    const syncData = async () => {
      if (!loading) {
          let gradeNo:number = Number(localStorage.getItem('lastGradePage') ?? '0');
          if (gradeNo>0) {
            setLoading9(true);
            setLoading10(true);
            setLoading11(true);
            setLoading12(true);
            setLoading13(true);
            await gpaForecastServices.syncGpaForecastGradeNo(studentId, gradeNo);
            setLoading9(false);
            setLoading10(false);
            setLoading11(false);
            setLoading12(false);
            setLoading13(false);
          }
          await getData();
      }
    };
    syncData();
  }, []);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleRefresh = async () => {
    await runResync();
  };


  const grade9_columns = [
    {
      title: 'School Name',
      dataIndex: 'school_name',
      width: 120,
      editable: false,
    },
    {
      title: 'Course Name',
      dataIndex: 'course',
      width: 180,
      editable: false,
    },
    {
      title: 'Term',
      dataIndex: 'term',
      width: 80,
      editable: false,
    },
    {
      title: 'Grade',
      dataIndex: 'grade',
      width: 60,
      align: 'center',
      editable: false,
    },
    {
      title: 'Unweighted points',
      dataIndex: 'unweighted_point',
      width: 100,
      align: 'center',
      editable: true,
      editor: {
        required: true,
        validator: (rule:any,value:any,callback:any,record:any) => {
          if (value==='' || isNaN(Number(value))) {
            callback('You must input numbers!');
          }
          else {
            callback();
          }
        },
      },
    },
    {
      title: 'Weighted points',
      dataIndex: 'weighted_point',
      width: 100,
      align: 'center',
      editable: true,
    },
    {
      title: 'Credits',
      dataIndex: 'credit',
      width: 80,
      align: 'center',
      editable: false,
    },
  ];
  const grade9_custom_columns = [
    {
      title: 'School Name',
      dataIndex: 'school_name',
      width: 120,
      editable: false,
    },
    {
      title: 'Course Name',
      dataIndex: 'course',
      width: 180,
      editable: true,
    },
    {
      title: 'Term',
      dataIndex: 'term',
      width: 80,
      editable: false,
    },
    {
      title: 'Grade',
      dataIndex: 'grade',
      width: 60,
      align: 'center',
      editable: true,
    },
    {
      title: 'Unweighted points',
      dataIndex: 'unweighted_point',
      width: 100,
      align: 'center',
      editable: true,
      editor: {
        required: true,
        validator: (rule:any,value:any,callback:any,record:any) => {
          if (value==='' || isNaN(Number(value))) {
            callback('You must input numbers!');
          }
          else {
            callback();
          }
        },
      },
    },
    {
      title: 'Weighted points',
      dataIndex: 'weighted_point',
      width: 100,
      align: 'center',
      editable: true,
    },
    {
      title: 'Credits',
      dataIndex: 'credit',
      width: 80,
      align: 'center',
      editable: true,
    },
  ];

  const grade10_columns = [
    {
      title: 'School Name',
      dataIndex: 'school_name',
      width: 120,
      editable: false,
    },
    {
      title: 'Course Name',
      dataIndex: 'course',
      width: 180,
      editable: false,
    },
    {
      title: 'Term',
      dataIndex: 'term',
      width: 80,
      editable: false,
    },
    {
      title: 'Grade',
      dataIndex: 'grade',
      width: 60,
      align: 'center',
      editable: false,
    },
    {
      title: 'Unweighted points',
      dataIndex: 'unweighted_point',
      width: 100,
      align: 'center',
      editable: true,
      editor: {
        required: true,
        validator: (rule:any,value:any,callback:any,record:any) => {
          if (value==='' || isNaN(Number(value))) {
            callback('You must input numbers!');
          }
          else {
            callback();
          }
        },
      },
    },
    {
      title: 'Weighted points',
      dataIndex: 'weighted_point',
      width: 100,
      align: 'center',
      editable: true,
    },
    {
      title: 'Credits',
      dataIndex: 'credit',
      width: 80,
      align: 'center',
      editable: false,
    },
  ];
  const grade10_custom_columns = [
    {
      title: 'School Name',
      dataIndex: 'school_name',
      width: 120,
      editable: false,
    },
    {
      title: 'Course Name',
      dataIndex: 'course',
      width: 180,
      editable: true,
    },
    {
      title: 'Term',
      dataIndex: 'term',
      width: 80,
      editable: false,
    },
    {
      title: 'Grade',
      dataIndex: 'grade',
      width: 60,
      align: 'center',
      editable: true,
    },
    {
      title: 'Unweighted points',
      dataIndex: 'unweighted_point',
      width: 100,
      align: 'center',
      editable: true,
      editor: {
        required: true,
        validator: (rule:any,value:any,callback:any,record:any) => {
          if (value==='' || isNaN(Number(value))) {
            callback('You must input numbers!');
          }
          else {
            callback();
          }
        },
      },
    },
    {
      title: 'Weighted points',
      dataIndex: 'weighted_point',
      width: 100,
      align: 'center',
      editable: true,
    },
    {
      title: 'Credits',
      dataIndex: 'credit',
      width: 80,
      align: 'center',
      editable: true,
    },
  ];


  const grade11_columns = [
    {
      title: 'School Name',
      dataIndex: 'school_name',
      width: 120,
      editable: false,
    },
    {
      title: 'Course Name',
      dataIndex: 'course',
      width: 180,
      editable: false,
    },
    {
      title: 'Term',
      dataIndex: 'term',
      width: 80,
      editable: false,
    },
    {
      title: 'Grade',
      dataIndex: 'grade',
      width: 60,
      align: 'center',
      editable: false,
    },
    {
      title: 'Unweighted points',
      dataIndex: 'unweighted_point',
      width: 100,
      align: 'center',
      editable: true,
      editor: {
        required: true,
        validator: (rule:any,value:any,callback:any,record:any) => {
          if (value==='' || isNaN(Number(value))) {
            callback('You must input numbers!');
          }
          else {
            callback();
          }
        },
      },
    },
    {
      title: 'Weighted points',
      dataIndex: 'weighted_point',
      width: 100,
      align: 'center',
      editable: true,
    },
    {
      title: 'Credits',
      dataIndex: 'credit',
      width: 80,
      align: 'center',
      editable: false,
    },
  ];
  const grade11_custom_columns = [
    {
      title: 'School Name',
      dataIndex: 'school_name',
      width: 120,
      editable: false,
    },
    {
      title: 'Course Name',
      dataIndex: 'course',
      width: 180,
      editable: true,
    },
    {
      title: 'Term',
      dataIndex: 'term',
      width: 80,
      editable: false,
    },
    {
      title: 'Grade',
      dataIndex: 'grade',
      width: 60,
      align: 'center',
      editable: true,
    },
    {
      title: 'Unweighted points',
      dataIndex: 'unweighted_point',
      width: 100,
      align: 'center',
      editable: true,
      editor: {
        required: true,
        validator: (rule:any,value:any,callback:any,record:any) => {
          if (value==='' || isNaN(Number(value))) {
            callback('You must input numbers!');
          }
          else {
            callback();
          }
        },
      },
    },
    {
      title: 'Weighted points',
      dataIndex: 'weighted_point',
      width: 100,
      align: 'center',
      editable: true,
    },
    {
      title: 'Credits',
      dataIndex: 'credit',
      width: 80,
      align: 'center',
      editable: true,
    },
  ];

  const grade12_columns = [
    {
      title: 'School Name',
      dataIndex: 'school_name',
      width: 120,
      editable: false,
    },
    {
      title: 'Course Name',
      dataIndex: 'course',
      width: 180,
      editable: false,
    },
    {
      title: 'Term',
      dataIndex: 'term',
      width: 80,
      editable: false,
    },
    {
      title: 'Grade',
      dataIndex: 'grade',
      width: 60,
      align: 'center',
      editable: false,
    },
    {
      title: 'Unweighted points',
      dataIndex: 'unweighted_point',
      width: 100,
      align: 'center',
      editable: true,
      editor: {
        required: true,
        validator: (rule:any,value:any,callback:any,record:any) => {
          if (value==='' || isNaN(Number(value))) {
            callback('You must input numbers!');
          }
          else {
            callback();
          }
        },
      },
    },
    {
      title: 'Weighted points',
      dataIndex: 'weighted_point',
      width: 100,
      align: 'center',
      editable: true,
    },
    {
      title: 'Credits',
      dataIndex: 'credit',
      width: 80,
      align: 'center',
      editable: false,
    },
  ];
  const grade12_custom_columns = [
    {
      title: 'School Name',
      dataIndex: 'school_name',
      width: 120,
      editable: false,
    },
    {
      title: 'Course Name',
      dataIndex: 'course',
      width: 180,
      editable: true,
    },
    {
      title: 'Term',
      dataIndex: 'term',
      width: 80,
      editable: false,
    },
    {
      title: 'Grade',
      dataIndex: 'grade',
      width: 60,
      align: 'center',
      editable: true,
    },
    {
      title: 'Unweighted points',
      dataIndex: 'unweighted_point',
      width: 100,
      align: 'center',
      editable: true,
      editor: {
        required: true,
        validator: (rule:any,value:any,callback:any,record:any) => {
          if (value==='' || isNaN(Number(value))) {
            callback('You must input numbers!');
          }
          else {
            callback();
          }
        },
      },
    },
    {
      title: 'Weighted points',
      dataIndex: 'weighted_point',
      width: 100,
      align: 'center',
      editable: true,
    },
    {
      title: 'Credits',
      dataIndex: 'credit',
      width: 80,
      align: 'center',
      editable: true,
    },
  ];

  const grade13_columns = [
    {
      title: 'School Name',
      dataIndex: 'school_name',
      width: 120,
      editable: false,
    },
    {
      title: 'Course Name',
      dataIndex: 'course',
      width: 180,
      editable: false,
    },
    {
      title: 'Term',
      dataIndex: 'term',
      width: 80,
      editable: false,
    },
    {
      title: 'Grade',
      dataIndex: 'grade',
      width: 60,
      align: 'center',
      editable: false,
    },
    {
      title: 'Unweighted points',
      dataIndex: 'unweighted_point',
      width: 100,
      align: 'center',
      editable: true,
      editor: {
        required: true,
        validator: (rule:any,value:any,callback:any,record:any) => {
          if (value==='' || isNaN(Number(value))) {
            callback('You must input numbers!');
          }
          else {
            callback();
          }
        },
      },
    },
    {
      title: 'Weighted points',
      dataIndex: 'weighted_point',
      width: 100,
      align: 'center',
      editable: true,
    },
    {
      title: 'Credits',
      dataIndex: 'credit',
      width: 80,
      align: 'center',
      editable: false,
    },
  ];
  const grade13_custom_columns = [
    {
      title: 'School Name',
      dataIndex: 'school_name',
      width: 120,
      editable: false,
    },
    {
      title: 'Course Name',
      dataIndex: 'course',
      width: 180,
      editable: true,
    },
    {
      title: 'Term',
      dataIndex: 'term',
      width: 80,
      editable: false,
    },
    {
      title: 'Grade',
      dataIndex: 'grade',
      width: 60,
      align: 'center',
      editable: true,
    },
    {
      title: 'Unweighted points',
      dataIndex: 'unweighted_point',
      width: 100,
      align: 'center',
      editable: true,
      editor: {
        required: true,
        validator: (rule:any,value:any,callback:any,record:any) => {
          if (value==='' || isNaN(Number(value))) {
            callback('You must input numbers!');
          }
          else {
            callback();
          }
        },
      },
    },
    {
      title: 'Weighted points',
      dataIndex: 'weighted_point',
      width: 100,
      align: 'center',
      editable: true,
    },
    {
      title: 'Credits',
      dataIndex: 'credit',
      width: 80,
      align: 'center',
      editable: true,
    },
  ];


  const handleFormChange9Data = (values:any)=>{
    console.log('run handleFormChange9Data')
    if(currentRow9Data){
      const isExistRow = changedData9Data.find(c => c.id === currentRow9Data.id);

      if(!isExistRow){
        const updateData:any[] = [...changedData9Data, { id:currentRow9Data.id, ...values, isUpdate: true}];
        setChangedData9Data(updateData);
      }else {
        const updateData:any[] = changedData9Data.map((c:any) => {
          if (c.id === currentRow9Data.id) {
            return _.merge({}, c, values);
          } else {
            return c;
          }
        });
        setChangedData9Data(updateData);
      }
    }
  };
  
  const handleFormChange9Custom = (values:any)=>{
    if(currentRow9Custom){
      const isExistRow = changedData9Custom.find(c => c.id === currentRow9Custom.id);

      if(!isExistRow){
        const updateData:any[] = [...changedData9Custom, { id:currentRow9Custom.id, ...values, isUpdate: true}];
        setChangedData9Custom(updateData);
      }else {
        const updateData:any[] = changedData9Custom.map((c:any) => {
          if (c.id === currentRow9Custom.id) {
            return _.merge({}, c, values);
          } else {
            return c;
          }
        });
        setChangedData9Custom(updateData);
      }
    }
  };

  const onChangedDataUpdate9Data = async (dataArr:any) => {
    let updatedDataSource:any[] = [...gpaForecast9Data];
    setLoading9(true);
    try {
      for(let i=0; i< dataArr.length; i++) {
        let data = dataArr[i];
        let row = updatedDataSource.find(c => c.id === data.id);
        if (row) {
          if (data.isUpdate) {
            if (data.hasOwnProperty('unweighted_point')) {
              let unweighted_point = Number(data.unweighted_point);
              row.is_weight_point = false;
              // if (row.unweighted_point!== unweighted_point) {
              //   row.is_override = true;
              // }
              row.unweighted_point = unweighted_point;
              // if (row.weighted_point !== 0) {
              //   row.weighted_point = 0;
              //   row.is_override = true;
              // }

              await gpaForecastDetailServices.updateGpaForeCastDetail({
                id: row.id,
                gpa_forecast_id: row.gpa_forecast_id,
                is_custom: row.is_custom,
                is_override: true, 
                seq_no: row.seq_no,
                school_name: row.school_name,
                summer_course: row.summer_course,
                course: row.course,
                term: row.term,
                grade: row.grade,
                is_weight_point: row.is_weight_point,
                unweighted_point: row.unweighted_point,
                weighted_point: row.weighted_point,
              });
              setGpaForecast9Data(updatedDataSource);
            }
            if (data.hasOwnProperty('weighted_point')) {
              let weighted_point = Number(data.weighted_point);
              row.is_weight_point = true;
              // if (row.weighted_point!== weighted_point) {
              //   row.is_override = true;
              // }
              row.weighted_point = weighted_point;
              // if (row.unweighted_point !== 0) {
              //   row.unweighted_point = 0;
              //   row.is_override = true;
              // }
              
              await gpaForecastDetailServices.updateGpaForeCastDetail({
                id: row.id,
                gpa_forecast_id: row.gpa_forecast_id,
                is_custom: row.is_custom,
                is_override: true, 
                seq_no: row.seq_no,
                school_name: row.school_name,
                summer_course: row.summer_course,
                course: row.course,
                term: row.term,
                grade: row.grade,
                is_weight_point: row.is_weight_point,
                unweighted_point: row.unweighted_point,
                weighted_point: row.weighted_point,
              });
              setGpaForecast9Data(updatedDataSource);
            }
            await refreshGpa();
          }
          else {
            if (data.isDelete) {
              updatedDataSource= gpaForecast9Data.filter((o:any) => o.id !== data.id);
              let ret = await gpaForecastDetailServices.deleteGpaForeCastDetail(data.id);
              if (ret) {
                setGpaForecast9Data(updatedDataSource);
                await refreshGpa();
              }
            }
          }   
        }
      }   
    }
    catch(ex){
      console.log('Error:', ex);    
    }
    setLoading9(false);
  }

  const onChangedDataUpdateData = async (dataArr:any, gradeNo: number) => {  
    const setUpdateGpaForecastData = (ds:any[], gradeNo:number) =>{
      switch(gradeNo) {
        case 9:
          setGpaForecast9Data(ds);
          break;
        case 10:
          setGpaForecast10Data(ds);
          break;
        case 11:
          setGpaForecast11Data(ds);
          break;
        case 12:
          setGpaForecast12Data(ds);
          break;          
      }
    }

    let gpaForecastData:any[] = [];
    let updatedDataSource:any[] = [];
    switch(gradeNo) {
      case 9:
        gpaForecastData = gpaForecast9Data;
        updatedDataSource = [...gpaForecast9Data];
        break;
      case 10:
        gpaForecastData = gpaForecast10Data;
        updatedDataSource = [...gpaForecast10Data];
        break;
      case 11:
        gpaForecastData = gpaForecast11Data;
        updatedDataSource = [...gpaForecast11Data];
        break;
      case 12:
        gpaForecastData = gpaForecast12Data;
        updatedDataSource = [...gpaForecast12Data];
        break;
    }
    setLoadingNo(gradeNo, true);
    try {
      for(let i=0; i< dataArr.length; i++) {
        let data = dataArr[i];
        let row = updatedDataSource.find(c => c.id === data.id);
        if (row) {
          if (data.isUpdate) {
            if (data.hasOwnProperty('unweighted_point')) {
              let unweighted_point = Number(data.unweighted_point);
              row.is_weight_point = false;
              row.unweighted_point = unweighted_point;
            }
            if (data.hasOwnProperty('weighted_point')) {
              let weighted_point = Number(data.weighted_point);
              row.is_weight_point = true;
              row.weighted_point = weighted_point;           
            }

            await gpaForecastDetailServices.updateGpaForeCastDetail({
              id: row.id,
              gpa_forecast_id: row.gpa_forecast_id,
              is_custom: row.is_custom,
              is_override: true, 
              seq_no: row.seq_no,
              school_name: row.school_name,
              summer_course: row.summer_course,
              course: row.course,
              term: row.term,
              grade: row.grade,
              is_weight_point: row.is_weight_point,
              unweighted_point: row.unweighted_point,
              weighted_point: row.weighted_point,
            });
            setUpdateGpaForecastData(updatedDataSource, gradeNo);
            await refreshGpa();
          }
          else {
            if (data.isDelete) {
              updatedDataSource= gpaForecastData.filter((o:any) => o.id !== data.id);
              let ret = await gpaForecastDetailServices.deleteGpaForeCastDetail(data.id);
              if (ret) {
                setUpdateGpaForecastData(updatedDataSource, gradeNo);
                await refreshGpa();
              }
            }
          }   
        }
      }
    }
    catch(ex){
      console.log('Error:', ex);
    }
    setLoadingNo(gradeNo, false);
  }
  
  const setLoadingNo = (gradeNo: number, value:boolean) => {
    switch(gradeNo) {
      case 9:
        setLoading9(value);
        break;
      case 10:
        setLoading10(value);
        break;
      case 11:
        setLoading11(value);
        break;
      case 12:
        setLoading12(value);
        break;
      case 13:
        setLoading13(value);
        break;        
    }    
  }

  const onChangedDataUpdateCustom = async (dataArr:any, gradeNo: number) => {
    const setUpdateGpaForecastCustom = (ds:any[], gradeNo:number) =>{
      switch(gradeNo) {
        case 9:
          setGpaForecast9Custom(ds);
          break;
        case 10:
          setGpaForecast10Custom(ds);
          break;
        case 11:
          setGpaForecast11Custom(ds);
          break;
        case 12:
          setGpaForecast12Custom(ds);
          break;
        case 13:
          setGpaForecast13Custom(ds);
          break;
      }
    };

    let updatedDataSource:any[] = [];
    switch(gradeNo) {
      case 9:
        updatedDataSource = [...gpaForecast9Custom];
        break;
      case 10:
        updatedDataSource = [...gpaForecast10Custom];
        break;
      case 11:
        updatedDataSource = [...gpaForecast11Custom];
        break;
      case 12:
        updatedDataSource = [...gpaForecast12Custom];
        break;
    }
    setLoadingNo(gradeNo, true);
    try {
      for(let i=0; i< dataArr.length; i++) {
        let data = dataArr[i];
        let row = updatedDataSource.find(c => c.id === data.id);
        if (row) {
          if (data.isUpdate) {
            row.is_custom = true;
            if (data.hasOwnProperty('course')) {
              row.course = data.course;
            }
            if (data.hasOwnProperty('grade')) {
              row.grade = data.grade;
            }
            if (data.hasOwnProperty('unweighted_point')) {
              let unweighted_point = Number(data.unweighted_point);
              row.is_weight_point = false;
              row.unweighted_point = unweighted_point;
            }
            if (data.hasOwnProperty('weighted_point')) {
              let weighted_point = Number(data.weighted_point);
              row.is_weight_point = true;
              row.weighted_point = weighted_point;
            }

            let res = await gpaForecastDetailServices.updateGpaForeCastDetail({
              id: row.id,
              gpa_forecast_id: row.gpa_forecast_id,
              is_custom: row.is_custom,
              is_override: row.is_override,
              seq_no: row.seq_no,
              school_name: row.school_name,
              summer_course: row.summer_course,
              course: row.course,
              term: row.term,
              grade: row.grade,
              is_weight_point: row.is_weight_point,
              unweighted_point: row.unweighted_point,
              weighted_point: row.weighted_point,
            });
            setUpdateGpaForecastCustom(updatedDataSource, gradeNo);
            await refreshGpa();
          }
          else {
            if (data.isDelete) {
              updatedDataSource = updatedDataSource.filter((o:any) => o.id !== data.id);

              let ret = await gpaForecastDetailServices.deleteGpaForeCastDetail(data.id);
              if (ret) {
                setUpdateGpaForecastCustom(updatedDataSource, gradeNo);
                updateCalcAllData();
                await refreshGpa();
              }

            }
          }   
        }
      }   
    }
    catch(ex){
      console.log('Error:', ex);
    }
    setLoadingNo(gradeNo, false);
  }

  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[
          { percentOnProcess: 30, title: 'Review/Edit Unweighted points' },
          { percentOnProcess: 45, title: 'Add Weighted points' },
          { percentOnProcess: 70, title: 'Add Additional Courses' },
          { percentOnProcess: 88, title: 'Review Forecasted GPA' },          
        ]}
        title="GPA Forecaster"
        process={1}
        icon={<EventNoteOutlinedIcon />}
        isMobile={isMobile}
      />

      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '120px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form 
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%',
              margin: '0 auto'
            }} 
            className="gm-form-grid"          
          >
            <div className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                GPA Forecaster
              </span>
            </div>
              <div className="m-0">
                <div className={`d-flex text-field-mid ${isMobile ? 'fs-6' : 'fs-5'} ${isMobile ? 'mb-2 py-2' : 'mb-3 py-4'}`}>
                  Non-GPA Courses are not included in the table below.
                </div>
              </div>
              <div className="row">
                  <div className="col-md-12">
                      <h2 id="grade9th" style={{ fontSize: isMobile ? '18px' : '24px' }}>Grade 9th</h2>
                  </div>
                  <div className="col-md-12">
                    <div 
                      className={isMobile ? "table-responsive-mobile" : ""}
                      style={isMobile ? {
                        overflowX: 'auto',
                        WebkitOverflowScrolling: 'touch',
                        width: '100%'
                      } : {}}
                    >
                      <AntForm form={form9} onValuesChange={handleFormChange9Data} >
                        <EditableTable
                          loading={loading9}
                          cols={grade9_columns}
                          data={gpaForecast9Data}
                          showToolbar={false}
                          showAddBtn={false}
                          showHeader={false}
                          showTopPager={false}
                          showBottomPager={false}
                          showSelectRecord={false}
                          currentPage={currentPage9Data}
                          onChangedDataUpdate={async(d:any)=>{
                              setChangedData9Data(d);
                              await onChangedDataUpdate9Data(d);
                              await refreshGpa();
                          }}
                          onSelectRow={(rows:any)=>{
                            setCurrentRow9Data(rows[0])
                          }}
                        />
                      </AntForm>
                    </div>
                  </div>
                  <div className="col-md-12 py-3">
                    <h3 className={isMobile ? 'fs-6' : 'fs-5'} style={{ fontSize: isMobile ? '16px' : '18px' }}>Grade 9th - Custom Data</h3>
                    <div 
                      className={isMobile ? "table-responsive-mobile" : ""}
                      style={isMobile ? {
                        overflowX: 'auto',
                        WebkitOverflowScrolling: 'touch',
                        width: '100%'
                      } : {}}
                    >
                      <AntForm form={form9Custom} >
                        <EditableTable
                          loading={loading9}
                          cols={grade9_custom_columns}
                          data={gpaForecast9Custom}
                          showToolbar={false}
                          showButtons={!openAddDialog9}
                          showAddBtn={false}
                          showHeader={false}
                          showTopPager={false}
                          showBottomPager={false}
                          showSelectRecord={false}
                          showDeleteButton={true}
                          currentPage={currentPage9Custom}
                          onChangedDataUpdate={async(d:any)=>{
                              setChangedData9Custom(d);
                              await onChangedDataUpdateCustom(d, 9);
                              await refreshGpa();
                          }}
                          onSelectRow={(rows:any)=>{
                            setCurrentRow9Custom(rows[0])
                          }}
                          buttons={(
                            <>
                              {!openAddDialog9 && (
                              <Button 
                                id={`btnAddCourse9`} 
                                className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} btn btn-primary`}
                                onClick={(e:any)=>{
                                  setOpenAddDialog9(true);
                                }}
                                style={{
                                  fontSize: isMobile ? '16px' : '14px',
                                  minHeight: isMobile ? '44px' : 'auto'
                                }}
                              >
                                Add Course
                              </Button>
                              )}
                            </> 
                          )}  
                        />
                      </AntForm>
                    </div>
                    <FormCreateGpaForecastModal
                      gradeNo={9}
                      options={schoolOptions9}
                      open={openAddDialog9}
                      handleSave={async(values:any) => {
                        console.log('save9 values:', values);
                        setOpenAddDialog9(false);
                        setLoading9(true);
                        try {
                          let seq_no = genSeqNoDetails(gpaForecast9Custom);
                          await gpaForecastDetailServices.createGpaForeCastDetail({
                            gpa_forecast_id: Number(values.gpa_forecast_id),
                            student_id: studentId,
                            is_custom: true,
                            is_override: false,
                            seq_no: seq_no,
                            school_name: values.school_name,
                            summer_course: false,
                            course: values.course,
                            term: values.term,
                            grade: values.grade,
                            credit: values.credit,
                            is_weight_point: values.is_weight_point,
                            unweighted_point: Number(values.unweighted_point ?? 0),
                            weighted_point: Number(values.weighted_point ?? 0),
                          });
                          updateCalcAllData();
                          await refreshGpa();
                        }
                        catch(ex){
                          console.log('Error: ', ex);
                        }
                        setLoading9(false);
                      }}
                      onClose={() => {
                        setOpenAddDialog9(false);
                        scrollToObject('grade9th', 100);
                      }}
                    />
                  </div>
                  <div className="d-flex w-100 justify-content-end pb-4">
                    <div className="d-flex">
                    <SumarryTable
                      column={[
                        { label: '', value: 'grade', fontsize5: true},
                        { label: 'Unweighted points', value: 'unweighted_point', align: 'center'},
                        { label: 'Weighted points', value: 'weighted_point', align: 'center'},
                      ]}
                      data = {gpaForecast9Average}
                      minWidth={120}
                     />
                    </div>
                  </div>
                  <hr/>

                  <div className="col-md-12 py-4">
                    <h2 id="grade10th" style={{ fontSize: isMobile ? '18px' : '24px' }}>Grade 10th</h2>
                  </div>
                  <div className="col-md-12">
                    <div 
                      className={isMobile ? "table-responsive-mobile" : ""}
                      style={isMobile ? {
                        overflowX: 'auto',
                        WebkitOverflowScrolling: 'touch',
                        width: '100%'
                      } : {}}
                    >
                      <AntForm form={form10}>
                        <EditableTable
                          loading={loading10}
                          cols={grade10_columns}
                          data={gpaForecast10Data}
                          showToolbar={false}
                          showAddBtn={false}
                          showHeader={false}
                          showTopPager={false}
                          showBottomPager={false}
                          showSelectRecord={false}
                          currentPage={currentPage10Data}
                          onChangedDataUpdate={async(d:any)=>{
                              setChangedData10Data(d);
                              await onChangedDataUpdateData(d, 10);
                              await refreshGpa();
                          }}
                          onSelectRow={(rows:any)=>{
                            setCurrentRow10Data(rows[0])
                          }}
                        />
                      </AntForm>
                    </div>
                  </div>
                  <div className="col-md-12 py-3">
                    <h3 className={isMobile ? 'fs-6' : 'fs-5'} style={{ fontSize: isMobile ? '16px' : '18px' }}>Grade 10th - Custom Data</h3>
                    <div 
                      className={isMobile ? "table-responsive-mobile" : ""}
                      style={isMobile ? {
                        overflowX: 'auto',
                        WebkitOverflowScrolling: 'touch',
                        width: '100%'
                      } : {}}
                    >
                      <AntForm form={form10Custom} >
                        <EditableTable
                          loading={loading10}
                          cols={grade10_custom_columns}
                          data={gpaForecast10Custom}
                          showToolbar={false}
                          showButtons={!openAddDialog10}
                          showAddBtn={false}
                          showHeader={false}
                          showTopPager={false}
                          showBottomPager={false}
                          showSelectRecord={false}
                          showDeleteButton={true}
                          currentPage={currentPage10Custom}
                          onChangedDataUpdate={async(d:any)=>{
                              setChangedData10Custom(d);
                              await onChangedDataUpdateCustom(d, 10);
                              await refreshGpa();
                          }}
                          onSelectRow={(rows:any)=>{
                            setCurrentRow10Custom(rows[0])
                          }}
                          buttons={(
                            <>
                            {!openAddDialog10 && (
                            <Button 
                              id={`btnAddCourse10`} 
                              className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} btn btn-primary`}
                              onClick={(e:any)=>{
                                setOpenAddDialog10(true);
                              }}
                              style={{
                                fontSize: isMobile ? '16px' : '14px',
                                minHeight: isMobile ? '44px' : 'auto'
                              }}
                            >
                              Add Course
                            </Button>
                            )}
                            </>                         
                          )}  
                        />
                      </AntForm>
                    </div>
                    <FormCreateGpaForecastModal
                      gradeNo={10}
                      options={schoolOptions10}
                      open={openAddDialog10}
                      handleSave={async(values:any) => {
                        setOpenAddDialog10(false);
                        setLoading10(true);
                        try {
                          let seq_no = genSeqNoDetails(gpaForecast10Custom);
                          await gpaForecastDetailServices.createGpaForeCastDetail({
                            gpa_forecast_id: Number(values.gpa_forecast_id),
                            student_id: studentId,
                            is_custom: true,
                            is_override: false,
                            seq_no: seq_no,
                            school_name: values.school_name,
                            summer_course: false,
                            course: values.course,
                            term: values.term,
                            grade: values.grade,
                            credit: values.credit,
                            is_weight_point: values.is_weight_point,
                            unweighted_point: Number(values.unweighted_point ?? 0),
                            weighted_point: Number(values.weighted_point ?? 0),
                          });
                          updateCalcAllData();
                          await refreshGpa();
                        }
                        catch(ex) {
                          console.log('Error: ', ex);
                        }
                        setLoading10(false);
                      }}
                      onClose={() => {
                        setOpenAddDialog10(false);
                        scrollToObject('grade10th', 100);
                      }}
                    />
                  </div>
                  <div className="d-flex w-100 justify-content-end pb-4">
                    <div className="d-flex">
                    <SumarryTable
                      column={[
                        { label: '', value: 'grade', fontsize5: true},
                        { label: 'Unweighted points', value: 'unweighted_point', align: 'center'},
                        { label: 'Weighted points', value: 'weighted_point', align: 'center'},
                      ]}
                      data = {gpaForecast10Average}
                      minWidth={120}
                     />
                    </div>
                  </div>
                  <hr/>

                  <div className="col-md-12 py-4">
                    <h2 id="grade11th" style={{ fontSize: isMobile ? '18px' : '24px' }}>Grade 11th</h2>
                  </div>
                  <div className="col-md-12">
                    <div 
                      className={isMobile ? "table-responsive-mobile" : ""}
                      style={isMobile ? {
                        overflowX: 'auto',
                        WebkitOverflowScrolling: 'touch',
                        width: '100%'
                      } : {}}
                    >
                      <AntForm form={form11} >
                        <EditableTable
                          loading={loading11}
                          cols={grade11_columns}
                          data={gpaForecast11Data}
                          showToolbar={false}
                          showAddBtn={false}
                          showHeader={false}
                          showTopPager={false}
                          showBottomPager={false}
                          showSelectRecord={false}
                          currentPage={currentPage11Data}
                          onChangedDataUpdate={async (d:any)=>{
                              setChangedData11Data(d);
                              await onChangedDataUpdateData(d, 11);
                              await refreshGpa();
                          }}
                          onSelectRow={(rows:any)=>{
                            setCurrentRow11Data(rows[0])
                          }}
                        />
                      </AntForm>
                    </div>
                  </div>
                  <div className="col-md-12 py-3">
                    <h3 className={isMobile ? 'fs-6' : 'fs-5'} style={{ fontSize: isMobile ? '16px' : '18px' }}>Grade 11th - Custom Data</h3>
                    <div 
                      className={isMobile ? "table-responsive-mobile" : ""}
                      style={isMobile ? {
                        overflowX: 'auto',
                        WebkitOverflowScrolling: 'touch',
                        width: '100%'
                      } : {}}
                    >
                      <AntForm form={form11Custom} >
                        <EditableTable
                          loading={loading11}
                          cols={grade11_custom_columns}
                          data={gpaForecast11Custom}
                          showToolbar={false}
                          showButtons={!openAddDialog11}
                          showAddBtn={false}
                          showHeader={false}
                          showTopPager={false}
                          showBottomPager={false}
                          showSelectRecord={false}
                          showDeleteButton={true}
                          currentPage={currentPage11Custom}
                          onChangedDataUpdate={async (d:any)=>{
                              setChangedData11Custom(d);
                              await onChangedDataUpdateCustom(d, 11);
                              await refreshGpa();
                          }}
                          onSelectRow={(rows:any)=>{
                            setCurrentRow11Custom(rows[0])
                          }}
                          buttons={(
                            <>
                            {!openAddDialog11 && (
                            <Button 
                              id={`btnAddCourse11`} 
                              className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} btn btn-primary`}
                              onClick={(e:any)=>{
                                setOpenAddDialog11(true);
                              }}
                              style={{
                                fontSize: isMobile ? '16px' : '14px',
                                minHeight: isMobile ? '44px' : 'auto'
                              }}
                            >
                              Add Course
                            </Button>
                            )}
                            </>
                          )}  
                        />
                      </AntForm>
                    </div>
                    <FormCreateGpaForecastModal
                      gradeNo={11}                    
                      options={schoolOptions11}
                      open={openAddDialog11}
                      handleSave={async(values:any) => {
                        setOpenAddDialog11(false);
                        setLoading11(true);
                        try {
                          let seq_no = genSeqNoDetails(gpaForecast11Custom);
                          await gpaForecastDetailServices.createGpaForeCastDetail({
                            gpa_forecast_id: Number(values.gpa_forecast_id),
                            student_id: studentId,
                            is_custom: true,
                            is_override: false,
                            seq_no: seq_no,
                            school_name: values.school_name,
                            summer_course: false,
                            course: values.course,
                            term: values.term,
                            grade: values.grade,
                            credit: values.credit,
                            is_weight_point: values.is_weight_point,
                            unweighted_point: Number(values.unweighted_point ?? 0),
                            weighted_point: Number(values.weighted_point ?? 0),
                          });
                          updateCalcAllData();
                          await refreshGpa();
                        }
                        catch(ex){
                          console.log('Error:',ex);
                        }
                        setLoading11(false);
                      }}
                      onClose={() => {
                        setOpenAddDialog11(false);
                        scrollToObject('grade11th', 100);
                      }}
                    />
                  </div>
                  <div className="d-flex w-100 justify-content-end pb-4">
                    <div className="d-flex">
                    <SumarryTable
                      column={[
                        { label: '', value: 'grade', fontsize5: true},
                        { label: 'Unweighted points', value: 'unweighted_point', align: 'center'},
                        { label: 'Weighted points', value: 'weighted_point', align: 'center'},
                      ]}
                      data = {gpaForecast11Average}
                      minWidth={120}
                     />
                    </div>
                  </div>
                  <hr />

                  <div className="col-md-12 py-4">
                    <h2 id="grade12th" style={{ fontSize: isMobile ? '18px' : '24px' }}>Grade 12th</h2>
                  </div>
                  <div className="col-md-12">
                    <div 
                      className={isMobile ? "table-responsive-mobile" : ""}
                      style={isMobile ? {
                        overflowX: 'auto',
                        WebkitOverflowScrolling: 'touch',
                        width: '100%'
                      } : {}}
                    >
                      <AntForm form={form12} >
                        <EditableTable
                          loading={loading12}
                          cols={grade12_columns}
                          data={gpaForecast12Data}
                          showToolbar={false}
                          showAddBtn={false}
                          showHeader={false}
                          showTopPager={false}
                          showBottomPager={false}
                          showSelectRecord={false}
                          currentPage={currentPage12Data}
                          onChangedDataUpdate={async (d:any)=>{
                              setChangedData12Data(d);
                              await onChangedDataUpdateData(d, 12);
                              await refreshGpa();
                          }}
                          onSelectRow={(rows:any)=>{
                            setCurrentRow12Data(rows[0])
                          }}
                        />
                      </AntForm>
                    </div>
                  </div>
                  <div className="col-md-12 py-3">
                    <h3 className={isMobile ? 'fs-6' : 'fs-5'} style={{ fontSize: isMobile ? '16px' : '18px' }}>Grade 12th - Custom Data</h3>
                    <div 
                      className={isMobile ? "table-responsive-mobile" : ""}
                      style={isMobile ? {
                        overflowX: 'auto',
                        WebkitOverflowScrolling: 'touch',
                        width: '100%'
                      } : {}}
                    >
                      <AntForm form={form12Custom} >
                        <EditableTable
                          loading={loading12}
                          cols={grade12_custom_columns}
                          data={gpaForecast12Custom}
                          showToolbar={false}
                          showButtons={!openAddDialog12}
                          showAddBtn={false}
                          showHeader={false}
                          showTopPager={false}
                          showBottomPager={false}
                          showSelectRecord={false}
                          showDeleteButton={true}
                          currentPage={currentPage12Custom}
                          onChangedDataUpdate={async (d:any)=>{
                              console.log('onChangedDataUpdate gpaForecast12Custom :', d);
                              setChangedData12Custom(d);
                              await onChangedDataUpdateCustom(d, 12);
                              await refreshGpa();
                          }}
                          onSelectRow={(rows:any)=>{
                            setCurrentRow12Custom(rows[0])
                          }}
                          buttons={(
                            <>
                            {!openAddDialog12 && (
                            <Button 
                              id={`btnAddCourse12`} 
                              className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} btn btn-primary`}
                              onClick={(e:any)=>{
                                setOpenAddDialog12(true);
                              }}
                              style={{
                                fontSize: isMobile ? '16px' : '14px',
                                minHeight: isMobile ? '44px' : 'auto'
                              }}
                            >
                              Add Course
                            </Button>
                            )}
                            </>
                          )}  
                        />
                      </AntForm>
                    </div>
                    <FormCreateGpaForecastModal
                      gradeNo={12}                    
                      options={schoolOptions12}
                      open={openAddDialog12}
                      handleSave={async(values:any) => {
                        setOpenAddDialog12(false);
                        setLoading12(true);
                        try {
                          let seq_no = genSeqNoDetails(gpaForecast12Custom);
                          let ret = await gpaForecastDetailServices.createGpaForeCastDetail({
                            gpa_forecast_id: Number(values.gpa_forecast_id),
                            student_id: studentId,
                            is_custom: true,
                            is_override: false,
                            seq_no: seq_no,
                            school_name: values.school_name,
                            summer_course: false,
                            course: values.course,
                            term: values.term,
                            grade: values.grade,
                            credit: values.credit,
                            is_weight_point: values.is_weight_point,
                            unweighted_point: Number(values.unweighted_point ?? 0),
                            weighted_point: Number(values.weighted_point ?? 0),
                          });
                          console.log('createGpaForeCastDetail ret:', ret);
                          updateCalcAllData();
                          await refreshGpa();
                        }
                        catch(ex){
                          console.log('Error:', ex);
                        }
                        setLoading12(false);
                      }}
                      onClose={() => {
                        setOpenAddDialog12(false);
                        scrollToObject('grade12th', 100);
                      }}
                    />
                  </div>
                  <div className="d-flex w-100 justify-content-end pb-4">
                    <div className="d-flex">
                      <SumarryTable
                        column={[
                          { label: '', value: 'grade', fontsize5: true},
                          { label: 'Unweighted points', value: 'unweighted_point', align: 'center'},
                          { label: 'Weighted points', value: 'weighted_point', align: 'center'},
                        ]}
                        data = {gpaForecast12Average}
                        minWidth={120}
                      />
                    </div>
                  </div>
                  <hr />


                  <div className="col-md-12 py-4">
                    <h2 id="grade12th" style={{ fontSize: isMobile ? '18px' : '24px' }}>College Courses</h2>
                  </div>
                  <div className="col-md-12">
                    <div 
                      className={isMobile ? "table-responsive-mobile" : ""}
                      style={isMobile ? {
                        overflowX: 'auto',
                        WebkitOverflowScrolling: 'touch',
                        width: '100%'
                      } : {}}
                    >
                      <AntForm form={form12} >
                        <EditableTable
                          loading={loading13}
                          cols={grade12_columns}
                          data={gpaForecast13Data}
                          showToolbar={false}
                          showAddBtn={false}
                          showHeader={false}
                          showTopPager={false}
                          showBottomPager={false}
                          showSelectRecord={false}
                          currentPage={currentPage13Data}
                          onChangedDataUpdate={async (d:any)=>{
                              setChangedData13Data(d);
                              await onChangedDataUpdateData(d, 12);
                              await refreshGpa();
                          }}
                          onSelectRow={(rows:any)=>{
                            setCurrentRow13Data(rows[0])
                          }}
                        />
                      </AntForm>
                    </div>
                  </div>
                  <div className="col-md-12 py-3">
                    <h3 className={isMobile ? 'fs-6' : 'fs-5'} style={{ fontSize: isMobile ? '16px' : '18px' }}>College Course - Custom Data</h3>
                    <div 
                      className={isMobile ? "table-responsive-mobile" : ""}
                      style={isMobile ? {
                        overflowX: 'auto',
                        WebkitOverflowScrolling: 'touch',
                        width: '100%'
                      } : {}}
                    >
                      <AntForm form={form13Custom} >
                        <EditableTable
                          loading={loading13}
                          cols={grade13_custom_columns}
                          data={gpaForecast13Custom}
                          showToolbar={false}
                          showButtons={!openAddDialog13}
                          showAddBtn={false}
                          showHeader={false}
                          showTopPager={false}
                          showBottomPager={false}
                          showSelectRecord={false}
                          showDeleteButton={true}
                          currentPage={currentPage13Custom}
                          onChangedDataUpdate={async (d:any)=>{
                              console.log('onChangedDataUpdate gpaForecast13Custom :', d);
                              setChangedData13Custom(d);
                              await onChangedDataUpdateCustom(d, 13);
                              await refreshGpa();
                          }}
                          onSelectRow={(rows:any)=>{
                            setCurrentRow13Custom(rows[0])
                          }}
                          buttons={(
                            <>
                            {!openAddDialog13 && (
                            <Button 
                              id={`btnAddCourse13`} 
                              className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} btn btn-primary`}
                              onClick={(e:any)=>{
                                setOpenAddDialog13(true);
                              }}
                              style={{
                                fontSize: isMobile ? '16px' : '14px',
                                minHeight: isMobile ? '44px' : 'auto'
                              }}
                            >
                              Add Course
                            </Button>
                            )}
                            </>
                          )}  
                        />
                      </AntForm>
                    </div>
                    <FormCreateGpaForecastModal
                      gradeNo={13}                    
                      options={schoolOptions13}
                      open={openAddDialog13}
                      handleSave={async(values:any) => {
                        setOpenAddDialog13(false);
                        setLoading13(true);
                        try {
                          let seq_no = genSeqNoDetails(gpaForecast12Custom);
                          let ret = await gpaForecastDetailServices.createGpaForeCastDetail({
                            gpa_forecast_id: Number(values.gpa_forecast_id),
                            student_id: studentId,
                            is_custom: true,
                            is_override: false,
                            seq_no: seq_no,
                            school_name: values.school_name,
                            summer_course: false,
                            course: values.course,
                            term: values.term,
                            grade: values.grade,
                            credit: values.credit,
                            is_weight_point: values.is_weight_point,
                            unweighted_point: Number(values.unweighted_point ?? 0),
                            weighted_point: Number(values.weighted_point ?? 0),
                          });
                          console.log('createGpaForeCastDetail ret:', ret);
                          updateCalcAllData();
                          await refreshGpa();
                        }
                        catch(ex){
                          console.log('Error:', ex);
                        }
                        setLoading12(false);
                      }}
                      onClose={() => {
                        setOpenAddDialog13(false);
                        scrollToObject('grade13th', 100);
                      }}
                    />
                  </div>
                  <div className="d-flex w-100 justify-content-end pb-4">
                    <div className="d-flex">
                      <SumarryTable
                        column={[
                          { label: '', value: 'grade', fontsize5: true},
                          { label: 'Unweighted points', value: 'unweighted_point', align: 'center'},
                          { label: 'Weighted points', value: 'weighted_point', align: 'center'},
                        ]}
                        data = {gpaForecast13Average}
                        minWidth={120}
                      />
                    </div>
                  </div>
                  <hr />


              </div>
            <div className={`${isMobile ? 'my-2' : 'my-3'} d-flex ${isMobile ? 'flex-column' : 'justify-content-end'} border-top ${isMobile ? 'pt-2' : 'pt-3'}`}>
              <div className={`${isMobile ? 'w-100' : 'col col-md-6'} text-center ${isMobile ? '' : 'text-md-end'}`}>
                <div className={`d-flex ${isMobile ? 'flex-column gap-2' : 'flex-row'} justify-content-center`}>
                  <Button 
                    variant="primary" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-4'}`}
                    onClick={() => handleRefresh()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Refresh Data
                  </Button>
                  <Button 
                    variant="primary" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'}`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Container>
    </>
  );
};

export default GpaForecaster;